import { makeAutoObservable } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import reportSalesByCategoryService from '../services/ReportSalesByCategoryService';


class ReportSalesByCategoryStore {
    loading: boolean = false;
    reportList: any = [];
    sort?: string = '';
    totalPages: number = 0;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'categoryName',
    }

    constructor() {
        makeAutoObservable(this);
    }

    async getList(params: any) {
        this.loading = true;
        const pagination = params.page
        const size = params.size
        delete params.page;
        delete params.size;

        const response = await reportSalesByCategoryService.getList(params, pagination, size);

        if (!response.error) {
            this.reportList = response.data.content;
            this.totalPages = response.data.totalPages;
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
        }
        this.loading = false;

        return response;
    }
}

const reportSalesByCategoryStore = new ReportSalesByCategoryStore();
export default reportSalesByCategoryStore;